import _ from 'lodash';

export function getLabelByJudgmentSubtype(subtypeArgument) {
  const subtype = _.get(this, `subtypes.${[subtypeArgument]}`, {});
  const subtypeDisplayName = _.get(subtype, 'displayName', '');
  return `Sentencia ${subtypeDisplayName}`;
}
